import { Link, useLocation } from "react-router-dom";
import { ChevronDownIcon } from "@heroicons/react/outline";

function SideNavOptionHelper({
  data,
  Icon,
  IconColor,
  lable,
  isOpen,
  onToggle,
  collapsed, // ✅ NEW PROP
}) {
  const location = useLocation();

  return (
    <div className="mt-2 relative group">
      {/* HEADER */}
      <div
        onClick={onToggle}
        className={`flex items-center justify-between px-3 py-2 mx-2 rounded-lg cursor-pointer transition-all duration-200
        ${isOpen ? "bg-gray-100" : "hover:bg-gray-50"}
        ${collapsed ? "justify-center" : ""}
        `}
      >
        <div className="flex items-center gap-3 relative">
          <Icon className={`h-5 w-5 ${IconColor}`} />

          {/* LABEL (hidden when collapsed) */}
          {!collapsed && (
            <span className="text-sm font-medium text-gray-700">
              {lable}
            </span>
          )}

          {/* ✅ TOOLTIP */}
          {collapsed && (
            <div className="absolute left-10 z-50 whitespace-nowrap rounded-md bg-gray-800 text-white text-xs px-2 py-1 opacity-0 group-hover:opacity-100 transition">
              {lable}
            </div>
          )}
        </div>

        {!collapsed && (
          <ChevronDownIcon
            className={`h-4 w-4 text-gray-400 transition-transform duration-200 ${
              isOpen ? "rotate-180" : ""
            }`}
          />
        )}
      </div>

      {/* DROPDOWN */}
      {isOpen && data?.title && !collapsed && (
        <div className="mt-1 transition-all duration-200">
          {data.title.map(([title, link]) => {
            const isActive = location.pathname === link;

            return (
              <Link
                key={link}
                to={link}
                className={`flex items-center py-2 ml-6 mr-2 rounded-md text-sm transition-all
                ${
                  isActive
                    ? "bg-teal-50 text-green-600 pl-[14px]"
                    : "text-gray-600 hover:bg-gray-50 pl-4"
                }`}
              >
                {title}
              </Link>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default SideNavOptionHelper;